var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScannerOverlayDocBackNoMrz = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2147_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 0.333496H4C1.79086 0.333496 0 2.12436 0 4.3335V49.6668C0 51.8759 1.79086 53.6668 4 53.6668H76C78.2091 53.6668 80 51.8759 80 49.6668V4.3335C80 2.12436 78.2091 0.333496 76 0.333496Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 0.333496H4C1.79086 0.333496 0 2.12436 0 4.3335V49.6668C0 51.8759 1.79086 53.6668 4 53.6668H76C78.2091 53.6668 80 51.8759 80 49.6668V4.3335C80 2.12436 78.2091 0.333496 76 0.333496Z",
    fill: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8691 29.0878V33.5144L59.9378 33.5246C67.3611 33.5964 71.5418 36.8977 72.6317 43.5882C68.5543 38.8711 63.8524 38.8691 59.9489 38.8681H58.8691V43.2573L48.8662 36.172L58.8691 29.0878ZM59.9489 27L47 36.172L59.9489 45.3441V39.9479C65.1316 39.95 69.9367 40.2111 74 47.4572C74 42.8555 73.24 32.5743 59.9489 32.4457V27Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2147_256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 54,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScannerOverlayDocBackNoMrz);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/scanner-overlay-doc-back-no-mrz.bdf7f5e15f0d90db2da89924fd1f748b.svg";